import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { Popover, styled, useTheme } from '@mui/material';
import { IEmoji } from 'src/@types/chat';
import { PopoverProps } from 'src/components/PopoverTrigger';
import getPosition from 'src/components/menu-popover/getPosition';

export type EmojiPickerPopoverProps = {
  onSelectEmoji: (emoji: IEmoji) => void;
  arrow: string;
};

const Container = styled('div')`
  em-emoji-picker {
    --shadow: none;
  }
`;

export const EmojiPickerPopover = ({
  target,
  handleClose,
  arrow,
  onSelectEmoji,
}: PopoverProps<EmojiPickerPopoverProps>) => {
  const theme = useTheme();

  const { anchorOrigin, transformOrigin } = getPosition(arrow);

  const HandleSelectEmoji = async (emoji: IEmoji) => {
    onSelectEmoji(emoji);
    handleClose();
  };

  return (
    <Popover
      open={!!target}
      anchorEl={target}
      onClose={handleClose}
      sx={{
        '& .MuiPaper-rounded': {
          borderRadius: 1,
          width: 352,
        },
      }}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
    >
      <Container
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
        }}
      >
        <Picker
          theme={theme.palette.mode}
          data={data}
          onEmojiSelect={HandleSelectEmoji}
        />
      </Container>
    </Popover>
  );
};
